
import React from 'react';
import { Button } from '@/components/ui/button';
import { Bluetooth, BluetoothSearching } from 'lucide-react';

interface BluetoothScanButtonProps {
  isScanning: boolean;
  isBluetoothAvailable: boolean;
  onClick: () => void;
}

const BluetoothScanButton: React.FC<BluetoothScanButtonProps> = ({
  isScanning,
  isBluetoothAvailable,
  onClick,
}) => (
  <div className="flex justify-center">
    <Button
      onClick={onClick}
      disabled={isScanning || !isBluetoothAvailable}
      className="flex items-center justify-center gap-2 px-6 py-6 text-white bg-blue-500 rounded-full shadow-md transition-all hover:bg-blue-600 active:scale-95 disabled:opacity-70"
    >
      {isScanning ? (
        <>
          <div className="animate-spin">
            <BluetoothSearching size={20} />
          </div>
          <span>Scanning...</span>
        </>
      ) : (
        <>
          <Bluetooth size={20} />
          <span>Scan for Transfer-Enabled Devices</span>
        </>
      )}
    </Button>
  </div>
);

export default BluetoothScanButton;
